export default {
  authToken: state => state.authToken,
  isAuthenticated: state => !!state.authToken,
};
